<template>
    <div class='h-dialogContainer h-nomargin'>
        <div class='row m-b-10'>
            <div class='nopadding'>
                <div class='h-borderBox height-320'>
                    <div class='h-borderBox'>
                        <div class='h-borderBox-top' >
                            <ejs-textbox  :placeholder='$t("Software.enterKeywordSearch")' @keydown.enter.native="searchMethod" v-model='input'/>
                        </div>
                        <ejs-grid ref="listNe" :dataSource='listdata' height='220'>
                            <e-columns>
                                <e-column type='checkbox' width='8%' ></e-column>
                                <e-column field='text' :headerText='$t("Software.td_neID")' width='15%' clipMode='EllipsisWithTooltip'></e-column>
                            </e-columns>
                        </ejs-grid>
                    </div>
                </div>
            </div>
        </div>
        <div class='b-t row h-row-around-inputBox'/>
        <div class='row'>
            <div class='h-col-inputBox h-marginT28 col-sm-12 nopadding'>
                <div class='col-sm-8 row nopadding'>
                    <div class='h-inputLit'>{{$t('Software.td_executionTime')}}</div>
                    <ejs-datetimepicker :locale='locale' :format="format" :timeFormat='timeFormat' v-model='timevalue'></ejs-datetimepicker>
                </div>
            </div>
            <div class='h-col-inputBox nopadding'>
                <div class="col-sm-2 row nopadding">
                    <span class="icon hero-icon hero-icon-detailed" style="line-height: 21px;padding:0 12px;">
                    </span>
                </div>
                <div class='col-sm-7 row nopadding'>
                    <div>{{$t('Software.backcaution')}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TopoTree from '../topoconfig/TopoTree'
import {stringify} from 'qs';
import { isNullOrUndefined } from "@syncfusion/ej2-base";
let Source =[];
export default {
    name: 'back-task',
    props: ['showToast'],
    components:{
        TopoTree
    },
    data() {
        return{
            format: 'yyyy-MM-dd HH:mm:ss',
            timeFormat: 'HH:mm:ss',
            timevalue: new Date(),
            locale: localStorage.getItem('locale'),
            listdata: [],
            input:'',
        }
    },
    methods: {
        backVersion(callback) {
            const checkNodes = this.$refs.listNe.getSelectedRecords();
            const NeIdList = Array.from(checkNodes, x => x.id);
            if(NeIdList.length == 0)
            {
                this.showToast('warning', `${this.$t('Software.selectDevice')}`);
                return;
            }
            let linkSelect = "";
            let equipmentIPId = "";
            for (var i = 0; i < this.listdata.length; i++) {
              if (this.listdata[i].id == NeIdList[0]) {
                equipmentIPId = this.listdata[i].equipmentIPId;
                if (undefined==this.listdata[i].equipmentIPId||this.listdata[i].equipmentIPId ==0) {
               //tr069升级GNB，链路需为tr069
                  this.showToast("warning", `此基站不支持升级`);
                  return;
                 }
                 linkSelect = this.listdata[i].linkSelect;
              }
            }
            if (NeIdList.length > 10) {
              //最多可在同一时间回滚10个BS
              this.showToast("warning", `Up to 10 BS can be rollback at the same time`);
              return;
            }
            if(linkSelect === 'tr069'){
              this.showToast("warning", `目前tr069版本不支持回退`);
            }
            let para = {
                neIdList: NeIdList,
            }
            let config = {
                headers: {
                    "Content-Type": "application/json"
                }
            };
            let params = {
                execTime: new Date(this.timevalue).Format("yyyy-MM-dd HH:mm:ss"),
                systemId: "1",
            };

      this.$layer.confirm({
          msg: this.$t('DeployManagement.backConfirm'),
          btn1: {
            msg: this.$t('Common.cancel')
          },
          btn2: {
            msg: this.$t('Common.ok'),
            func: () => {

            this.axios.post(`/lte/ems/verback_new/backVerAction?${stringify(params)}`, JSON.stringify(NeIdList), config).then(response => {
                callback();
                if(response.status == 200)
                {
                    if(response.data.errorCode == 'SUCCESS')
                    {
                        this.showToast('success', `${this.$t('Common.tips.success')}`);
                        console.log('update', response);
                    }
                    else {
                        this.showToast('error',response.data.errorString);
                    }
                }
                else{
                    this.showToast('error', `${this.$t('Common.tips.failure')}`);
                }
            });

            }
          }
        });
        },
        _getNeTreeData() {
            this.listdata = [];
            this.$axios.post('/lte/ems/auth/findEquipmentListByAuth',[10009,10004]).then((response) => {
                const _nodeArray = response.data;
                const showData = [];
                const showPrimaryDatas = [];
                _nodeArray.forEach((_item) => {
                    const { id, name, equipmentIP, equipmentIPId, typeCode,softwareVersion } = _item;
                    let _dataItem={}
                    if(typeCode==10009&&softwareVersion=="ssl"){
                       _dataItem = {
                      text: name,
                      id: id,
                      neType: typeCode,
                      tooltip: equipmentIP,
                      equipmentIPId: 0,
                      linkSelect:softwareVersion
                    };}else{
                     _dataItem = {
                      text: name,
                      id: id,
                      neType: typeCode,
                      tooltip: equipmentIP,
                      equipmentIPId: _item.EquipmentIP[0].id,
                      linkSelect:softwareVersion

                    };}
                    showData.push(_dataItem);
                });
                this.listdata = showData;
                Source = showData;
            });
        },
        searchMethod()
        {
            if(this.input === '') {
                this.listdata = Source;
            }
            else{
                this.listdata = this.search(this.input,Source,this.$refs.listNe.getColumns())
            }
        },
        search(input,source,columns,maparray) {
            var filterdata = source.filter( item => {
                let columntext = Array.from(columns, x => {
                    return x.field;
                });
                let feildData = Array.from(columntext, x => {
                    if(maparray && maparray.has(x)){
                        let value = maparray.get(x).get(item[x]);
                        return isNullOrUndefined(value) ? '' : value;
                    }
                    else{
                        return isNullOrUndefined(item[x]) ? '' : item[x] +'';
                    }
                });
                let filres = false;
                feildData.forEach(item => {
                    if(item.indexOf(input) > -1)
                    {
                        filres = true;
                    }
                });
                return filres;
            }).map( item => { return item });
            return filterdata;
        },
    }
};
</script>
<style>

</style>
